<template>
  <v-card>
    <v-btn
      absolute
      style="right: 10px; top: 10px"
      flat
      icon
      @click="$emit('close')"
      color="secondary"
    >
      <v-icon>close</v-icon>
    </v-btn>
    <v-card-text class="pa-0">
      <div v-if="cupom_model.url_imagem_codigo === ''"
        xs12
        class="text-xs-center headline font-weight-light secondary--text pa-3"
      >Inserir imagem 500X500</div>
    </v-card-text>
    <v-card-text v-if="cupom_model.url_imagem_codigo">
      <v-layout row wrap justify-center>
        <v-flex xs12 class="text-xs-center headline font-weight-light secondary--text mb-3">
          Pré-visualização do banner
        </v-flex>
        <v-flex xs8>
          <v-img :src="cupom_model.url_imagem_codigo" class="clickable"></v-img>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text v-else>
      <v-layout row wrap justify-center>
        <v-flex
          xs12
          class="text-xs-center headline font-weight-light secondary--text mb-3"
        >Banner atual</v-flex>
          <v-flex xs8 v-if="codigo_promocional.url_imagem_codigo">
            <v-img :src="codigo_promocional.url_imagem_codigo"></v-img>
          </v-flex>
          <v-flex
            v-else
            class="text-xs-center subheading font-weight-light error--text mb-3"
          >Você ainda não possui um banner cadastrado</v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn
        flat
        block
        @click="$refs.input.click()"
        class="grey--text text--darken-1"
      >
        CARREGAR IMAGEM
        <input
          type="file"
          style="display:none"
          accept="image/*"
          ref="input"
          @input="carregarImagem"
        />
      </v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-btn
        flat
        block
        @click="fechar"
        class="grey--text text--darken-1"
      >CANCELAR</v-btn>
      <v-btn
        flat
        block
        color="success"
        @click="salvarBanner"
        :loading="loading"
      >SALVAR E SAIR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
window.EXIF = require('exif-js')

export default {
  props: ['codigo_promocional'],
  data () {
    return {
      cupom_model: {
        url_imagem_codigo: ''
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    carregarImagem (event) {
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onload = event => {
          var image = new Image()
          image.src = event.target.result
          var self = this
          image.onload = function () {
            var height = this.height
            var width = this.width
            if (height !== 500 || width !== 500) {
              alert('A imagem deve ter tamanho 500x500 pixels')
              return false
            }
            self.cupom_model.url_imagem_codigo = event.target.result
            return true
          }
        }
        reader.readAsDataURL(imagem)
      }
    },
    salvarBanner () {
      this.$store
        .dispatch('atualizarBannerCodigoPromocional', {
          codigo: this.codigo_promocional.id,
          imagem: this.cupom_model.url_imagem_codigo
        })
        .then(() => {
          this.$emit('success')
          this.fechar()
        })
    },
    fechar () {
      this.cupom_model.url_imagem_codigo = ''
      this.$emit('close')
    }
  }
}
</script>
